import { AsyncField, Field, useFormContext } from '@oscar/form';
import { DatePicker } from '@oscar/theme';
import { Col, Icon, Input, Row, Select } from '@oscar/theme';
import { DatePickerPopulate, TextField } from 'common/components';
import { FORMAT_DATE } from 'common/constants';
import { APIS } from 'common/constants/endpoints';
import { getDateCorrect } from 'features/insulation/utils';
import { debounce } from 'lodash';
import moment from 'moment';
import React from 'react';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
const { Option } = Select;

export const RemovalDetail = ({
  statusRequest: { state, status },
}: {
  statusRequest: StatusInstance;
}) => {
  const [formContext] = useFormContext();
  const insulationRemovalDetail =
    formContext.selectors?.getInitalValue()?.insulationRemovalDetail;
  const disableDate = (current: any) => {
    const startDate = formContext.form?.getFieldValue('startDate');
    const endDate = formContext.form?.getFieldValue('endDate');
    if (current) {
      return (
        current < getDateCorrect(startDate) ||
        current > getDateCorrect(endDate).add(1, 'd')
      );
    }
  };
  return (
    <div className="removal-detail">
      <Row gutter={[20, 20]}>
        <Col span={12}>
          {state === 'EDIT' ? (
            <>
              <p className="label-normal">Work Leader Name</p>
              <Field name={['insulationRemovalDetail', 'workLeaderName']}>
                <Input maxLength={100} placeholder={`Work Leader Name`} />
              </Field>
            </>
          ) : (
            <Field name={['insulationRemovalDetail', 'workLeaderName']}>
              <TextField label="Work Leader Name" />
            </Field>
          )}
        </Col>
        <Col span={12}>
          {state === 'EDIT' ? (
            <>
              <p className="label-normal">Insulation Removal Completion</p>
              <Field name={['insulationRemovalDetail', 'completationDate']}>
                <DatePickerPopulate
                  inputReadOnly={true}
                  format={FORMAT_DATE.SHORT_MONTH_DATE}
                  // disabledDate={disableDate}
                />
              </Field>
            </>
          ) : (
            <Field name={['insulationRemovalDetail', 'completationDate']}>
              <TextField
                label="Insulation Removal Completion"
                isDate
                formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
              />
            </Field>
          )}
        </Col>
      </Row>
      {insulationRemovalDetail &&
        insulationRemovalDetail?.overallAcceptance !== null && (
          <Row gutter={[20, 20]}>
            <Col span={12}>
              <TextField
                label="QAQC Result"
                value={
                  insulationRemovalDetail?.overallAcceptance
                    ? 'Accepted'
                    : 'Rejected'
                }
              />
            </Col>
            <Col span={12}>
              <Field name={['insulationRemovalDetail', 'submitedDate']}>
                <TextField
                  label="Date"
                  isDate
                  formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
                />
              </Field>
            </Col>
          </Row>
        )}
    </div>
  );
};

export default RemovalDetail;
